import { BPanel, Col, Progress, Button, FormGroup, FormControl } from '@sketchpixy/rubix';
import React from 'react';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import ReactDOMServer from 'react-dom/server';
import { withRouter } from 'react-router';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';

import { getAvailabilityTotalCount, getReservedCount, getMemoFromDate } from '../../helpers/availabilities';

const jQuery = require('jquery');
require('fullcalendar/dist/fullcalendar.js');
require('fullcalendar/dist/locale/fr.js');

import { Memos } from '../../collections/memos/memos';
import { MemoComponent } from '../reservations/components/component-memo';

import { Reactive } from '../common/Reactive.mixin.js';

@withRouter
@Reactive({
	subscriptions: ["flights-type", "reservations-planner", "montgolfieres", "users", "places"],
})
export default class CalendarPageV2 extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		this.startDate = moment().startOf('week').toDate();
		this.endDate = moment().endOf('week').toDate();

	}

	componentDidMount() {
		let that = this;
		Tracker.nonreactive(() => {
			jQuery('#calendar').fullCalendar({
				locale: 'fr',
				height: jQuery('#calendar').height(),
        defaultView: 'basicWeek',
				selectable: false,
				eventAfterAllRender: (view) => {
					console.log("rerender");
					jQuery('textarea').keyup(function(e) {
						let content = jQuery(e.target).val();
						let id = jQuery(e.target).attr('id');

						console.log('update', id);
						Memos.update(id, { "$set": {content: content}});
					});
				},
				viewRender: (view, element) => {
					console.log("viewRender");
					if (this.startDate == moment(date).startOf('week').toDate()) return ;
					if (this.reloading) return ;
					console.log("pass test");

					this.reloading = false;

					const date = jQuery('#calendar').fullCalendar('getDate');
					this.startDate = moment(date).startOf('week').toDate();
					this.endDate = moment(date).endOf('week').toDate();

					this.subscriptions && this.subscriptions.available.stop();
					Tracker.nonreactive(() => {
						console.log("subscription launched");
						this.subscriptions = {};
						this.subscriptions.available = Meteor.subscribe("availableAndScheduledBetween", this.startDate, this.endDate, () => {
							console.log("subscription done");
							this.reloading = true;

							let $calendar = jQuery('#calendar');
							$calendar.fullCalendar('prev');
							$calendar.fullCalendar('next');
							$calendar.fullCalendar('refresh');
							/*let view = $calendar.fullCalendar('getView');
							view.unrenderDates();
							view.renderDates();*/

						});
					});

				},
				dayRender: (momentDate, cell) => {
					let date = momentDate.toDate();

					console.log('la date', date);

					let anjou = ReactDOMServer.renderToStaticMarkup(
						<div className="calendar">
							<BPanel header="Angers">
								<Col sm={12}>
									<p>{ (getAvailabilityTotalCount(date, "anjou", "evening") - getReservedCount(date, "anjou", "morning")) + " places (matin)"}</p>
									<Progress striped bsStyle="info" value={(getReservedCount(date, "anjou", "morning") / getAvailabilityTotalCount(date, "anjou", "morning") * 100)} />
								</Col>
								<Col sm={12}>
									<p>{ (getAvailabilityTotalCount(date, "anjou", "evening") - getReservedCount(date, "anjou", "evening")) + " places (soir)"}</p>
									<Progress striped bsStyle="info" value={(getReservedCount(date, "anjou", "evening") / getAvailabilityTotalCount(date, "anjou", "evening") * 100)} />
									<br/>
								</Col>
							</BPanel>
						</div>
					);
					let nantes = ReactDOMServer.renderToStaticMarkup(
						<div className="calendar">
							<BPanel header="Nantes">
								<Col sm={12}>
									<p>{ (getAvailabilityTotalCount(date, "anjou", "evening") - getReservedCount(date, "nantes", "morning")) + " places (matin)"}</p>
									<Progress striped bsStyle="info" value={(getReservedCount(date, "nantes", "morning") / getAvailabilityTotalCount(date, "nantes", "morning") * 100)} />
								</Col>
								<Col sm={12}>
									<p>{ (getAvailabilityTotalCount(date, "anjou", "evening") - getReservedCount(date, "nantes", "evening")) + " places (soir)"}</p>
									<Progress striped bsStyle="info" value={(getReservedCount(date, "nantes", "evening") / getAvailabilityTotalCount(date, "nantes", "evening") * 100)} />
									<br/>
								</Col>
							</BPanel>
							{!_.includes(Meteor.user().roles, 'partner') &&
							<center>
								<Button bsStyle="primary">Ouvrir</Button>
							</center>
							}
						</div>
					);

					let memos = ReactDOMServer.renderToStaticMarkup(
							<MemoComponent memo={getMemoFromDate(date)}></MemoComponent>
					);

					if(Meteor.user().roles == 'partner') {
						memos = '';
					}

					cell.html("<div class='calendar-day'><br/>" + memos + anjou + nantes + "</div>");

				},
				dayClick: function(event, jsEvent, view) {
					jQuery(jsEvent.target).focus();

					if(jsEvent.target.type != 'button')
						return ;

					if(!_.includes(Meteor.user().roles, 'partner'))
						that.props.router.push('/planning?date=' + event.format());
				}
			});
		});

	}

	componentWillUnmount() {
		this.subscriptions.available.stop();
	}


	render() {

		return (
			<div>
				<BPanel header="Calendrier des disponibilités">
					<Col sm={12}>
						<div id="calendar"></div>
					</Col>
				</BPanel>
			</div>
		);
	}
}

CalendarPageV2.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/CalendarV2.page.js
 **/